/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#getRotation__anchor
 */
export default pageNumber => window.documentViewer.getRotation(pageNumber);
